var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "owl-carousel standard-rem",
          class: _vm.carouselClass,
          attrs: { id: _vm.carouselId }
        },
        [
          _vm._l(_vm.carouselData, function(item, itemIdx) {
            return [
              _c(
                "div",
                { key: _vm.carouselId + "-" + itemIdx, staticClass: "item" },
                [
                  _c("div", { class: ["panel", "panel-" + _vm.colorVariant] }, [
                    _c("div", { staticClass: "panel-heading" }, [
                      item.END_DATE
                        ? _c(
                            "span",
                            {
                              class:
                                "badge due-" + _vm.getDueStatus(item.END_DATE)
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_due"
                                      )
                                    )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDate(item.END_DATE)) +
                                  " \n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        : _c(
                            "span",
                            { staticClass: "badge badge-secondary due-none" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_noDueDate"
                                  )
                                )
                              )
                            ]
                          )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "panel-body text-center",
                        class: "panel-body-" + _vm.carouselId
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top-center",
                                value: {
                                  content: item.NAME,
                                  trigger: "hover click"
                                },
                                expression:
                                  "{ content: item.NAME, trigger: 'hover click' }",
                                modifiers: { "top-center": true }
                              }
                            ],
                            staticClass: "col-xs-12 no-overflow"
                          },
                          [
                            _c("p", [
                              _c(
                                "strong",
                                { staticStyle: { "white-space": "nowrap" } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.NAME) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              !!item.COURSE_TITLE
                                ? _c("span", [
                                    _vm._v(_vm._s(item.COURSE_TITLE))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !!item.COURSE_SECTION_TITLE
                                ? _c("span", [
                                    _vm._v(_vm._s(item.COURSE_SECTION_TITLE))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              item.POINTS
                                ? _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_pointsWithPoints",
                                            { points: item.POINTS }
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    )
                                  ])
                                : _c("span", [_vm._v(" ")])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        item.TEST_RID && item.END_DATE
                          ? _c("span", { staticClass: "text-sm" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_testClosesAt",
                                      { time: _vm.getTime(item.END_DATE) }
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        item.TEST_RID && item.TEST_ENDED_FLG !== "Y"
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary standard-rem",
                                on: {
                                  click: function($event) {
                                    return _vm.openTest(item)
                                  }
                                }
                              },
                              [
                                _vm.role === "student"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.AssignmentsCarousel.takeTestText"
                                          )
                                        )
                                      )
                                    ])
                                  : _c("span", [_vm._v("Info")]),
                                _vm._v(" "),
                                _c("br")
                              ]
                            )
                          : item.GRADING_COMPLETE_FLG === "Y"
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary standard-rem",
                                on: {
                                  click: function($event) {
                                    return _vm.reviewTest(item)
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.AssignmentsCarousel.reviewTestText"
                                      )
                                    )
                                  )
                                ]),
                                _c("br")
                              ]
                            )
                          : item.DROPBOX_ASSIGNMENT_ID
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary standard-rem",
                                on: {
                                  click: function($event) {
                                    return _vm.openDropboxAssignment(item)
                                  }
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.classPage.AssignmentCarousel.classPage_uploadSubmission"
                                      )
                                    )
                                  )
                                ]),
                                _c("br")
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ]
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.$t("commonText.unauthorizedAccess"),
            show: _vm.showModal,
            "dialog-size": "sm",
            name: "AssignmentOwlCarousel",
            id: "carouselModal"
          },
          on: {
            close: function($event) {
              return _vm.closeModal()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(modalProps) {
                return [
                  _c("p", { attrs: { id: "OwlModalContent", tabindex: "0" } }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "commonText.parentAccountTestRestrictionMessage"
                          )
                        ) +
                        "\n\t\t\t"
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-transparent pull-right",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                    "\n\t\t\t"
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }